import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(Path, { d: "m8 3 4 8 5-5 5 15H2L8 3z", stroke: `${color}` })
    }
  );
};
Icon.displayName = "Mountain";
const Mountain = memo(themed(Icon));
export {
  Mountain
};
//# sourceMappingURL=mountain.js.map
